import { Container } from '../components/layout/Primitives';

export default function Sustainability() {
  return (
    <div className="animate-fade-in">
      <Container style={{ padding: '3.5rem 1.5rem 4rem', maxWidth: '56rem' }}>
        <h1 className="font-display" style={{ margin: 0, fontSize: 'clamp(2rem,4vw,3.25rem)' }}>Sustainability</h1>
        <p style={{ marginTop: '1rem', opacity: 0.78, lineHeight: 1.75 }}>
          We focus on quality-first production, lower-volume drops, and materials selected for long-term wear. We
          continue to improve traceability and packaging impact across each season.
        </p>
      </Container>
    </div>
  );
}
